import { AppRecord } from "../types"

/** Filters app list by the given categories */
const filterAppsByCategories =
  (categories?: string[]) =>
  (apps?: AppRecord[]): AppRecord[] => {
    if (!apps) return []
    if (!categories || categories.length === 0) return apps

    return apps.filter((app) => app.categories?.some((category) => categories.includes(category)))
  }

export default filterAppsByCategories
